import hasPermissionTo from "helpers/permission";

const CREATE_SCORECARDS = 'employee_management.manage_balanced_scorecards.create';
const BULK_UPDATE_SCORECARDS = 'employee_management.manage_balanced_scorecards.bulk_update';

/**
 * Permissions an action type needs, any one of them is enough. Mirrors the backend rules
 * (LIX-1777 phase 4); action types not listed only need access to the Actions page.
 */
const requiredPermissions = {
  create_balanced_scorecard: [CREATE_SCORECARDS],
  create_evaluation: [CREATE_SCORECARDS],
  change_first_scorecard: [CREATE_SCORECARDS],
  update_balanced_scorecard: [BULK_UPDATE_SCORECARDS, CREATE_SCORECARDS],
};

export function canRunAction(actionType, permissions) {
  const required = requiredPermissions[actionType];

  return !required || required.some(permission => hasPermissionTo(permission, permissions));
}
